import React from 'react';
import { Button } from './button';

export const Demo1 = () => {
  return (
    <Button isDisabled={false} buttonType="primary" size="m">
      Launch
    </Button>
  );
};

export const Demo2 = () => {
  return (
    <Button isDisabled={false} buttonType="secondary" size="l" arrow="right">
      Next
    </Button>
  );
};
